import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectDNALoadDate = createSelector([selectQbrState], ({ dnaLoadDate }) => dnaLoadDate)
